import { h } from "omi";

export function GemGraphic() {
  return (
    <svg width="93" height="78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M77.4323 40.25c-1.0862.4472-6.9639 9.0083-9.2001 11.7555-6.3888 7.8584-13.0333 15.7167-19.0388 23.9584M76.5383 40.1899c-6.5806.1278-13.1612-.6389-19.8056-.575-12.3306.1278-25.2361.6389-37.5667 1.8528M19.3949 42.2661c-1.2778-.8944 3.1944 4.5361 3.5778 4.8555 2.4277 2.1723 4.4083 4.8556 6.8361 7.0917 5.3027 4.7917 8.8805 10.6695 13.6722 15.8445 1.4694 1.6611 3.0028 4.1527 4.8555 5.3666M64.9102 26.9324c-3.7694-.1277-25.8111-.1916-33.6055.1917"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.166 41.6557c1.9167-1.7889 9.775-11.7555 12.3945-14.8222M65.166 26.8335c3.9611 4.025 7.7305 8.8806 11.7555 13.0972M56.6684 39.0999c-2.4278-3.3222-5.3667-8.1138-7.475-11.6277M38.332 39.9307c.5111-1.7889 8.1778-10.6055 9.8389-13.0972M58.1473 38.7167c-.2556.3194 5.2389-8.6889 6.5167-10.6056M37.8211 38.9724c-1.7889-4.2167-3.7694-8.1139-5.8777-12.1389M48.7461 74.0472c-1.7888-2.4278-8.625-25.6194-11.0527-34.4361M49.832 72.4499c2.0445-12.5222 5.8139-21.9138 7.7306-33.4777M12.394 28.4944C8.7523 26.5139 5.0468 24.7889 1.2773 23M24.0211 17.1863c-2.7472-3.0667-6.3889-5.3667-9.3277-8.2417M39.7602 1.2778c-.6389 3.7695.9583 7.6667 1.4055 11.3722M55.752 2.5557c-.0639.575-.1278 1.15-.1278 1.725-.1278 3.1944.0639 6.4528.1916 9.7111M72.832 18.7834c2.7473-3.9611 6.5167-7.2833 9.5195-11.1166M81.7773 30.0917c2.4917-2.5555 6.1973-3.8333 9.3917-5.175"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
